import React from 'react';
import './OrderVoucherSummary.scss';
import { Divider } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import OrderVoucher from './OrderVoucher';

interface IProps {
  orderVouchers: Julius.Website.OrderItemViewModel[];
  totalPrice: number;
}

const OrderVoucherSummary: React.SFC<IProps> = ({
  orderVouchers,
  totalPrice,
}) => {

  if (!orderVouchers || !orderVouchers.length) {
    return null;
  }

  return (
    <div className='order-voucher-summary'>
      <FormattedText 
        style='title black'
        displayName='Presentkort'
        formattedName='voucher.header'
      />
      <div className='header-container'>
        <div className='header'>
          <FormattedText 
            style='type-header'
            displayName='Typ'
            formattedName='global.type'  
          />
          <FormattedText 
            style='quantity-header'
            displayName='Antal'
            formattedName='global.quantity'
          />
          <FormattedText 
            style='price-header'
            displayName='Pris'
            formattedName='global.price'  
          />
        </div>
        <Divider />
      </div>
      { orderVouchers.map((o, key) => 
        <OrderVoucher key={ `voucher-${ key }` } item={ o } />)
      }
      <div className='total-price bold'>
        <FormattedText
          displayName='Summa'
          formattedName='global.sum'
          />
        <PriceItem price={ totalPrice } decimals={ 2 } />
      </div>
    </div>
  );
};

export default OrderVoucherSummary;


// WEBPACK FOOTER //
// ./src/components/OrderVoucherSummary/OrderVoucherSummary.tsx